import { z } from 'zod'

const jsonObject = z.record(z.unknown())
const allowlistEntry = z.object({
  method: z.string().regex(/^[A-Za-z]{1,16}$/).transform((value) => value.toUpperCase()).optional(),
  pathPattern: z
    .string()
    .min(1)
    .max(200)
    .refine((path) => path.startsWith('/'), { message: 'pathPattern must start with /' })
    .refine((path) => !path.includes('?'), { message: 'pathPattern must not carry a query' })
    .refine((path) => !path.includes('#'), { message: 'pathPattern must not carry a fragment' })
    .refine((path) => !path.includes('://'), { message: 'pathPattern must not carry a scheme' }),
  status: z.number().int().min(0).max(599),
}).strict()

export const tcpscreentruth23patchPatchScreenTruthTargetsAppScreenIdRoleDataStateViewportNetworkAllowlistRequestSchema = z.object({
  network_failure_allowlist: z.array(allowlistEntry).max(50),
}).strict()
export type tcpscreentruth23patchPatchScreenTruthTargetsAppScreenIdRoleDataStateViewportNetworkAllowlistRequest = z.infer<typeof tcpscreentruth23patchPatchScreenTruthTargetsAppScreenIdRoleDataStateViewportNetworkAllowlistRequestSchema>

export const tcpscreentruth23patchPatchScreenTruthTargetsAppScreenIdRoleDataStateViewportNetworkAllowlistResponseSchema = jsonObject
export type tcpscreentruth23patchPatchScreenTruthTargetsAppScreenIdRoleDataStateViewportNetworkAllowlistResponse = z.infer<typeof tcpscreentruth23patchPatchScreenTruthTargetsAppScreenIdRoleDataStateViewportNetworkAllowlistResponseSchema>
